import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const publicModules = {

  state: {

  },

  mutations: {

    login(state, data) {
      data.url = API.publicApi.login;
      CommonUtils.PostRequest(data);
    },

    logout(state, data) {
      data.url = API.publicApi.logout;
      CommonUtils.PostRequest(data);
    },

    modifyPassword(state, data) {
      data.url = API.publicApi.modifyPassword;
      CommonUtils.PostRequest(data);
    }

  }

};

export default publicModules;



// WEBPACK FOOTER //
// ./src/store/modules/public.js